export enum BackupSidePanelTab {
  general = 'general',
  tickets = 'tickets',
  license = 'license',
  backupPlans = 'backup-plans',
  restorePlans = 'restore-plans',
  backupStorage = 'backup-storage',
  backupHistory = 'backup-history',
  documents = 'documents',
  virtualMachines = 'virtual-machines',
  diagnostics = 'diagnostics',
  vmManagement = 'vm-management',
  agentSettingsGeneral = 'agent-settings-general',
  agentSettingsAdvanced = 'agent-settings-advanced'
}
